import { render, staticRenderFns } from "./ShipmentProgressStatus.vue?vue&type=template&id=fc592e50&"
import script from "./ShipmentProgressStatus.vue?vue&type=script&lang=js&"
export * from "./ShipmentProgressStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports